import { gql } from "@apollo/client";

export const QUERY = gql`
  query getCompanyLocation($companySlug: String, $locationSlug: String, $isUser: Boolean!) {
    company(slug: $companySlug) {
      id
      locationSet {
        id
        address
        company {
          id
          slug
          name
        }
        displayName
        locality {
          locality
          region
        }
        slug
        games {
          id
          gameimageSet {
            imageId
          }
          status
        }
      }
      locations(slug: $locationSlug) {
        address
        address2
        company {
          id
          name
          slug
        }
        coupons {
          id
          additionalDetails
          code
          discountDollars
          discountDollarsScope
          discountPercentage
          expirationDate
          title
        }
        description
        displayName
        games {
          isCompleted @include(if: $isUser)
          isSaved @include(if: $isUser)
          awards {
            id
            displayTitle
            category {
              source {
                awardName
                sourceName
              }
            }
          }
          kind
          difficulty
          closingAt
          communityRatingCount
          communityScoreBucket
          communityScorePercentages {
            percentage
            rating
          }
          gameimageSet {
            imageUrl
            imageId
            order
          }
          hasAwards
          id
          minutes
          name
          openingAt
          overallRating
          playersMax
          playersMin
          primaryCategory {
            id
            name
            slug
            parent {
              id
              name
              slug
            }
          }
          secondaryCategories {
            id
            name
            slug
          }
          slug
          status
          tags {
            id
          }
          timeslots(limit: 10) {
            datetime
            available
          }
          url
        }
        id
        isClaimed
        isPartnerLite
        locality {
          locality
          region
        }
        location {
          coordinates
        }
        phoneNumber
        slug
        url
      }
      name
      slug
      url
    }
  }
`;
